__turbopack_context__.v({
  "carousel": "SimpleCarousel-module-scss-module__dqHkAG__carousel",
  "container": "SimpleCarousel-module-scss-module__dqHkAG__container",
  "header": "SimpleCarousel-module-scss-module__dqHkAG__header",
  "navigation": "SimpleCarousel-module-scss-module__dqHkAG__navigation",
  "navigationDesktopHide": "SimpleCarousel-module-scss-module__dqHkAG__navigationDesktopHide",
  "slide": "SimpleCarousel-module-scss-module__dqHkAG__slide",
  "slideDesktopFive": "SimpleCarousel-module-scss-module__dqHkAG__slideDesktopFive",
  "slideDesktopFour": "SimpleCarousel-module-scss-module__dqHkAG__slideDesktopFour",
  "slideDesktopOne": "SimpleCarousel-module-scss-module__dqHkAG__slideDesktopOne",
  "slideDesktopSix": "SimpleCarousel-module-scss-module__dqHkAG__slideDesktopSix",
  "slideDesktopThree": "SimpleCarousel-module-scss-module__dqHkAG__slideDesktopThree",
  "slideDesktopTwo": "SimpleCarousel-module-scss-module__dqHkAG__slideDesktopTwo",
  "slideTabletFive": "SimpleCarousel-module-scss-module__dqHkAG__slideTabletFive",
  "slideTabletFour": "SimpleCarousel-module-scss-module__dqHkAG__slideTabletFour",
  "slideTabletOne": "SimpleCarousel-module-scss-module__dqHkAG__slideTabletOne",
  "slideTabletSix": "SimpleCarousel-module-scss-module__dqHkAG__slideTabletSix",
  "slideTabletThree": "SimpleCarousel-module-scss-module__dqHkAG__slideTabletThree",
  "slideTabletTwo": "SimpleCarousel-module-scss-module__dqHkAG__slideTabletTwo",
  "subtitle": "SimpleCarousel-module-scss-module__dqHkAG__subtitle",
  "title": "SimpleCarousel-module-scss-module__dqHkAG__title",
  "titleBucket": "SimpleCarousel-module-scss-module__dqHkAG__titleBucket",
  "wrapper": "SimpleCarousel-module-scss-module__dqHkAG__wrapper",
});
